import React, { Dispatch, ReactNode, SetStateAction } from "react";
import {
  AccordionContainer,
  ExpandableContent,
  MiniTitle,
  PixelTitle,
  ToggleButton,
} from "./styles";
import useIsMobile from "../hooks/useIsMobile";
import { Flex } from "../Layouts/styles";

const Accordion = ({
  title,
  secondTitle,
  children,
opened,
  setOpened,
  ref
}: {
  title: ReactNode;
  secondTitle: ReactNode;
  children: ReactNode;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  ref?: React.MutableRefObject<HTMLDivElement | null> | null;
}) => {
  const isMobile = useIsMobile();

  return (
    <AccordionContainer ref={ref}>
      <ToggleButton onClick={() => setOpened((prev) => !prev)}>
        {isMobile ? <MiniTitle>{secondTitle}</MiniTitle> : null}
        <Flex>
          <PixelTitle>{opened ? "-" : "+"}&nbsp;</PixelTitle>
          <PixelTitle>{title}</PixelTitle>
        </Flex>
        {!isMobile ? <MiniTitle>{secondTitle}</MiniTitle> : null}
      </ToggleButton>

      <ExpandableContent
        initial={{ height: "0" }}
        animate={{ height: opened ? "auto" : "0" }}
      >
        {children}
      </ExpandableContent>
    </AccordionContainer>
  );
};

export default Accordion;
